import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../ts/Glob';
import { ProgressBar } from '../../../../_common/platform/tsx/ProgressBar';
import { AppSettingsFlatCheckList, IMarkedItemsBoolean, ISetting } from '../AppSettingsFlatCheckList';

function getMarkedItems(value: ISetting[]) {
    const markedItems = {};

    if (value) {
        _.each(value['keyListMarked'], (key) => {
            markedItems[key] = true;
        });
    }

    return markedItems;
}

export default function AppSettingsExport(props: {
    value: ISetting[];
    glob: IGlob;
    onChange(value: { keyListMarked: string[] }, selectedItems: any[]): void;
}) {
    const [loading, setLoading] = React.useState(true);
    const [markedItems, setMarkedItems] = React.useState<IMarkedItemsBoolean>(getMarkedItems(props.value));
    const [values, setValues] = React.useState<ISetting[]>([]);

    React.useEffect(() => {
        props.glob.AQLQueries.callMethod('appSettings_GetValues', {
            keyList: []
        })
            .then(
                (resp: {
                    result: {
                        appSettings: {
                            [key: string]: string;
                        };
                    };
                }) => {
                    const values: ISetting[] = [];

                    _.each(resp.result.appSettings, (value, key) => {
                        values.push({
                            key: key,
                            value: value
                        });
                    });

                    setValues(values);
                }
            )
            .always(() => {
                setLoading(false);
            });
    }, []);

    const handleOnChange = React.useCallback(
        (marked: IMarkedItemsBoolean) => {
            if (props.onChange != null) {
                setMarkedItems(marked);

                const keyListMarked = _.keys(marked);

                props.onChange(
                    {
                        keyListMarked: keyListMarked
                    },
                    keyListMarked
                );
            }
        },
        [props.onChange]
    );

    let content: React.JSX.Element;

    if (loading) {
        content = <ProgressBar />;
    } else {
        content = (
            <AppSettingsFlatCheckList
                value={values}
                marked={markedItems}
                showValueKeys={true}
                onChange={handleOnChange}
            />
        );
    }

    return <div className="app-settings-export">{content}</div>;
}
